/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as ActionTypes from './actionsTypes';

const initialState = {
  planType: [],
  rebateProgramList: [],
  rebateProgramNameValue: '',
  selectedPlanType: '',
  rebateProgramValue: '',
  errors: [],
  rebateProgramName: '',
  isLoading: false,
  searchResult: [],
  allRebateProgram: false,
  numOfDays: '',
  searchScreenVar: {
    rebateProgramValue: '',
    selectedPlanType: '',
    numOfDays: '',
    allRebateProgram: false,
    rebateProgrameName: '',
  },
};
export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.GET_PLAN_TYPE_DATA:
      return { ...state, planType: action.payload };

    case ActionTypes.SET_SELECTED_ZERO_URA:
      return { ...state, ...action.payload };
    case ActionTypes.IS_LOADING_ZERO_URA:
      return { ...state, isLoading: action.isLoading };
    // For Search Screen result
    case ActionTypes.GET_OUTSTANDING_DISPUTES_NUM_DAYS:
      return {
        ...state,
        searchResult: action.searchResult,
      };
    case ActionTypes.REFRESH_OUTSTANDING_DISPUTES_AFTER_NUM_OF_DAYS:
      return { ...state, searchScreenVar: initialState.searchScreenVar };
    case ActionTypes.REFRESH_OUTSTANDING_DISPUTES_AFTER_NUM_OF_DAYS_DISPLAY:
      return { ...state, searchScreenVar: initialState.searchScreenVar };
    default:
      return state;
  }
};

export default reducer;
